import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, Form, Image, InputGroup } from 'react-bootstrap';
import { ICampaignDeliverables } from '../../../../interfaces/campaign.interface';
import { getDeliverableNumber } from '../../../../utils/campaignUtils';
import { DeliverableTask } from '../../../../constants/campaign';

interface IProps {
    index: number;
    deliverable: ICampaignDeliverables;
    deliverables: ICampaignDeliverables[];
}

const ViewDeliverable = ({ index, deliverable, deliverables }: IProps) => {
    return (
        <div className="tw-w-full tw-flex tw-items-start tw-gap-x-2">
            <span className="tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-full tw-font-bold tw-bg-purple-500 tw-text-white tw-text-base tw-p-3">
                {getDeliverableNumber(deliverables, deliverable.deliverable_number)}
            </span>
            <div className="tw-grow tw-flex tw-items-stretch tw-border tw-rounded-md tw-border-gray-250">
                <div className="tw-min-h-[60px] tw-max-h-[60px] md:tw-min-h-[87px] md:tw-max-h-[128px] tw-bg-gray-250 tw-w-[60px] md:tw-w-[128px]">
                    {deliverable.templateDetails &&
                    deliverable.templateDetails.preview_url.length > 0 ? (
                        <div className="tw-w-full tw-h-full tw-relative tw-group">
                            <Image
                                src={deliverable.templateDetails.preview_url}
                                fluid
                                className="tw-w-full tw-h-full tw-rounded-l-md"
                            />
                        </div>
                    ) : (
                        <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-gray-100">
                            <div className="tw-p-3 tw-bg-[#E5E7EB] tw-rounded-full tw-flex tw-items-center tw-justify-center">
                                <i className="ph-bold ph-image-square lg tw-text-[#9CA3AF]"></i>
                            </div>
                        </div>
                    )}
                </div>

                <div className="tw-flex-1 tw-p-4">
                    <div className="tw-w-full tw-flex tw-items-start tw-justify-between">
                        <div className="tw-flex tw-items-center tw-gap-x-2">
                            <div className="tw-py-1 tw-px-3 tw-rounded-md tw-bg-gray-100">
                                {deliverable.task}
                            </div>

                            {deliverable.task === DeliverableTask.CREATE_NEW_AD && (
                                <>
                                    <div className="tw-py-1 tw-px-3 tw-rounded-md tw-bg-gray-100">
                                        {deliverable.platform}
                                    </div>
                                    <div className="tw-py-1 tw-px-3 tw-rounded-md tw-bg-gray-100">
                                        {deliverable.asset_type}
                                    </div>
                                </>
                            )}
                        </div>

                        <div className="tw-flex tw-items-center tw-gap-x-2 tw-items-stretch">
                            {deliverable.user_product_path &&
                                deliverable.user_product_path.length > 0 && (
                                    <div className="productImage-deliverable">
                                        <div className="productImage-img">
                                            <Image
                                                src={deliverable.user_product_path}
                                                fluid
                                                style={{ width: '3rem', height: '3rem' }}
                                            />
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                    <div className="tw-w-full tw-pr-4 xl:tw-pr-10 tw-mt-2">
                        <div className="tw-text-base tw-rounded-md tw-py-1 tw-px-3">
                            {deliverable.content}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewDeliverable;
